module.exports = __webpack_public_path__ + "img/h-925-unit.00ffc8b7.png";